import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartComponent } from './pages/start/start.component'
import { ImeiComponent } from './pages/imei/imei.component'
import { ProductComponent } from './pages/product/product.component'
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component'
import { PersonalInfoComponent } from './pages/personal-info/personal-info.component'
import { PaymentComponent } from './pages/payment/payment.component'
import { CompleteComponent } from './pages/complete/complete.component'
import { UserInfoComponent } from './pages/user-info/user-info.component'
import { ImeiWithEmailComponent } from './pages/imei-with-email/imei-with-email.component'
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { AmazonComponent } from './pages/amazon/amazon.component';
import {AmazonRegisterFormCeQaComponent} from './pages/amazon/ce/qa/amazon-register-form-ce-qa.component';
import {AmazonRegisterFormCeProdComponent} from './pages/amazon/ce/prod/amazon-register-form-ce-prod.component';
import {AmazonRegisterFormMxQaComponent} from './pages/amazon/mx/qa/amazon-register-form-mx-qa.component';
import {AmazonRegisterFormMxProdComponent} from './pages/amazon/mx/prod/amazon-register-form-mx-prod.component';


const routes: Routes = [
  { path: '', redirectTo: '/start', pathMatch: 'full' },
  { path: 'start', component: StartComponent, pathMatch: 'full' },
  { path: 'imei', component: ImeiComponent, pathMatch: 'full' },
  { path: 'product', component: ProductComponent, pathMatch: 'full' },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent, pathMatch: 'full' },
  { path: 'personal-info', component: PersonalInfoComponent, pathMatch: 'full' },
  { path: 'payment', component: PaymentComponent, pathMatch: 'full' },
  { path: 'complete', component: CompleteComponent, pathMatch: 'full' },
  { path: 'user-info', component: UserInfoComponent, pathMatch: 'full' },
  { path: 'imei-with-email', component: ImeiWithEmailComponent, pathMatch: 'full' },
  { path: 'amazon/ce/qa', component: AmazonRegisterFormCeQaComponent, pathMatch: 'full' },
  { path: 'amazon/ce', component: AmazonRegisterFormCeProdComponent, pathMatch: 'full' },
  { path: 'amazon/mx/qa', component: AmazonRegisterFormMxQaComponent, pathMatch: 'full' },
  { path: 'amazon/mx', component: AmazonRegisterFormMxProdComponent, pathMatch: 'full' },
  { path: 'amazon', component: AmazonComponent, pathMatch: 'full' },
  { path: '404', component: NotfoundComponent },
  { path: '**', redirectTo: '/start'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
